import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({ name: 'showError' })
export class ShowErrorPipe implements PipeTransform {
  transform(control: AbstractControl, isFormSubmitted: boolean): any {
    return control?.invalid && (control?.touched || !!isFormSubmitted);
  }
}
